const Overrides = {
  MuiDataGrid: {
    defaultProps: {
      rowHeight: 40,
      columnHeaderHeight: 40
    },
    styleOverrides: {
      root: ({
        theme
      }) => ({
        fontFamily: 'inherit',
        fontWeight: 'inherit',
        border: 0,
        borderRadius: 0,
        boxShadow: 'none',
        backgroundColor: theme.palette.background.paper,
        '--DataGrid-containerBackground': theme.palette.background.paper,
        '--DataGrid-rowBorderColor': theme.palette.divider
      }),
      columnSeparator: ({
        theme
      }) => ({
        '&.MuiDataGrid-columnSeparator--resizable': {
          color: theme.palette.divider,
          '&:hover': {
            color: theme.palette.text.primary
          }
        }
      }),
      cell: ({
        theme
      }) => ({
        fontSize: theme.typography.body01.fontSize,
        '&:not(.MuiDataGrid-cell--editable):focus-within': {
          outline: 'none'
        },
        '&.MuiDataGrid-cell--editable': {
          display: 'grid',
          alignContent: 'center',
          justifyContent: 'stretch'
        },
        '&.MuiDataGrid-cell--editable .MuiDataGrid-cellContent': {
          backgroundColor: theme.palette.gray10,
          padding: `0 ${theme.spacing(0.5)}`,
          width: '100%',
          height: theme.spacing(4.5),
          lineHeight: theme.spacing(4.5)
        }
      }),
      columnHeaders: ({
        theme
      }) => ({
        '--DataGrid-t-header-background-base': theme.palette.background.paper
      }),
      columnHeader: () => ({
        '&:focus-within': {
          outline: 'none'
        }
      }),
      columnHeaderTitle: ({
        theme
      }) => ({
        ...theme.typography.body02
      }),
      footerContainer: ({
        theme
      }) => ({
        borderTop: `1px solid ${theme.palette.divider}`
      }),
      menu: {
        '.MuiPaper-root': {
          borderRadius: 0
        }
      }
    }
  }
};
const MuiDataGridOverrides = Overrides;

export { MuiDataGridOverrides };
